<template>
  <ValidationObserver v-slot="{ invalid, handleSubmit }" slim>
    <form @submit.prevent="handleSubmit(saveConfirmedEmail)" class="justify-content-between col-lg-12 py-3">
      <div class="form-row align-items-center py-3">
        <TextInputField
            class="form-group col-lg-6" v-model="emailString"
            labelText="e-mail" required email/>
      </div>

      <div class="form-row align-items-center py-3">
        <div class="input-group col-6">
          <button
              type="submit" :disabled="invalid"
              class="btn-basic btn-fill-pulse">
            Opslaan
          </button>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {ValidationObserver} from "vee-validate";
import TextInputField from "@/components/inputFields/TextInputField";

export default {
  name: "CreateConfirmedEmailComponent",
  components: {
    TextInputField,
    ValidationObserver
  },
  data() {
    return {
      emailString: "",
    };
  },
  computed: {
    ...mapGetters({
      isError: 'isError',
      isWarning: 'isWarning'
    })
  },
  created() {
  },
  methods: {
    ...mapActions("confirmedEmail", [
      'createConfirmedEmail',
    ]),
    saveConfirmedEmail() {
      this.createConfirmedEmail(this.emailString).then(() => {
        if (!this.isError) {
          this.$emit('toggleCreateEmail');
        }
      });
    }
  }
};
</script>
<style scoped>

.text-red {
  color: red;
}

</style>
